import { useState, useMemo } from "react";
import { useAutocomplete } from "@refinedev/mui";
import { Funder } from "@/interfaces/opportunities";

export const useFunderAutocomplete = (currentFunderUuid?: string) => {
  const [searchQuery, setSearchQuery] = useState("");

  const { autocompleteProps } = useAutocomplete({
    resource: "funders",
    pagination: { pageSize: 50 },
    defaultValue: currentFunderUuid,
    filters: [
      {
        field: "name",
        operator: "contains",
        value: searchQuery.trim(),
      },
    ],
  });

  const currentFunder = useMemo(() => {
    if (!currentFunderUuid || !autocompleteProps.options) return null;
    return autocompleteProps.options.find(
      (f: Funder) => f.uuid === currentFunderUuid
    );
  }, [currentFunderUuid, autocompleteProps.options]);

  return {
    searchQuery,
    setSearchQuery,
    autocompleteProps,
    currentFunder,
  };
};
